import service from '@/services/account';
import { changeLocale } from '@/i18n';

export const CACHE_KEY = 'opwCache';
export const STORE_KEY = 'opwStore';

const commitData = async (store, data) => {
  const {
    firstAdjustedWidgets: hasCustomizedWidgets,
    firstWidgetsInstallation: hasInstalledWidgets,
    importedReviews: hasImportedReviews,
    dashboardLanguage,
    pabook,
    qAndAActive,
    couponInfluencedOrdersTotalPaid,
    shopOwnerName,
    logoUrl,
    sendReviewRequests,
    ...account
  } = data;

  return Promise.all([
    store.commit('analytics/setInfluencedOrdersTotalPaid', couponInfluencedOrdersTotalPaid, {
      root: true,
    }),
    store.commit('analytics/setPabook', pabook, { root: true }),
    store.commit('settings/setShowQAndA', qAndAActive, { root: true }),
    store.commit('settings/setShopLanguage', dashboardLanguage, { root: true }),
    store.commit(
      'getAccountInfoSuccess',
      {
        ...account,
        logoUrl,
        hasInstalledWidgets,
        hasCustomizedWidgets,
        hasImportedReviews,
        user: {
          name: shopOwnerName,
          email: '',
          shopsManaged: [],
        },
      },
      {
        root: true,
      }
    ),
    dashboardLanguage && changeLocale(dashboardLanguage),
    store.commit('settings/setSendReviewRequests', sendReviewRequests, {
      root: true,
    }),
    store.commit('settings/setLogoUrl', logoUrl, { root: true }),
  ]);
};

const FirstDataFetcher = async store => {
  try {
    const storeId = store.getters['auth/getShopId'];
    sessionStorage.setItem(STORE_KEY, storeId);

    store.commit('updateLoadingCount', 1);

    const [{ data }] = await Promise.all([service.getEssentialData()]);
    await commitData(store, data);
    store.dispatch('loadAccountInfo');
    await store.commit('updateLoadingCount', -1);
  } catch (e) {
    console.error(e);
  }
};

export default FirstDataFetcher;
